export default __webpack_public_path__ + "static/media/f5.e0d33248.png";